/**
 * Decodes the HTML entities the library API embeds in human-readable strings.
 *
 * Location paths in particular arrive HTML-encoded from the backend, e.g.
 * "root &gt; Connections Education &gt; Connections Academy". Rendering that
 * verbatim shows the raw "&gt;" to users, so we decode the common entities for
 * display. "&amp;" is handled last so a single-encoded "&gt;" is not re-decoded.
 */
export function decodeHtmlEntities(value: string): string {
  return value
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#0*39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, '&');
}
